import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter, Inject,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { TelegramService } from '../../pages/page-telegram/telegram.service';
import { ModalService } from '../../services/modal.service';
import { isObject, isUndefined } from 'util';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NotifierWrapService } from '../../services/notifier-wrap.service';
import { from, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { Router } from '@angular/router';
import { Chat, IMessengerConnector } from '../../types/all.type';
import { AllService } from '../../services/all.service';
import {InterfaceService} from "../../services/interface.service";
import {AppService} from "../../services/app.service";
import {DcService} from '../../services/dc.service';

@Component({
  selector: 'app-chat-new',
  templateUrl: './chat-new.component.html',
  styleUrls: ['./chat-new.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChatNewComponent implements OnInit {
  public isLoadError = false;
  getAvalibleTimeout: NodeJS.Timeout;
  loadResultsSubscription: Subscription;
  @Output() onClose = new EventEmitter<any>();
  @Output() detectChange = new EventEmitter<any>();
  Form: UntypedFormGroup;
  arResult: any = [];
  public isLoaded = false;
  @Input() Service: IMessengerConnector;
  usersSelect: any = {};
  existChat: any;
  dismissible = true;
  defaultAlerts: any[] = [
    {
      type: 'success'
    }
  ];
  alerts = this.defaultAlerts;
  @ViewChild('scroll') scroll: ElementRef;

  constructor(
    private dcService: DcService,
    public interfaceService: InterfaceService,
    public allService: AllService,
    private router: Router,
    private cd: ChangeDetectorRef,
    public telegramService: TelegramService,
    public modalService: ModalService,
    public notifierWrapService: NotifierWrapService,
    public appService: AppService
  ) {}
  ngOnInit(): void {
    this.initForms();
    // this.loadContacts(true);
  }

  toggleUser(client): void {
    delete this.existChat;
    if (this.usersSelectCount === 0) {
      from(this.allService.arChat)
        .pipe(filter((v: any) => v.id === client.id))
        .subscribe((chat: Chat) => {
          this.existChat = chat;
        });
    } else {
      delete this.existChat;
    }

    if (isUndefined(this.usersSelect[client.id])) {
      this.usersSelect[client.id] = client;
      client.checked = true;
      // this.existChat = client;
    } else {
      client.checked = false;
      delete this.usersSelect[client.id];
      delete this.existChat;
    }
    this.cd.detectChanges();
    this.dcService.detectChanges$.next('contacts-list');
    setTimeout(() => {
      this.detectChange.next(client);
      this.cd.detectChanges();
    }, 100);
  }
  get usersSelectCount() {
    return Object.keys(this.usersSelect).length;
  }
  initForms() {
    this.Form = new UntypedFormGroup({
      title: new UntypedFormControl('', [Validators.required]),
      description: new UntypedFormControl('')
    });
  }
  scrollToTop(): void {
    this.scroll.nativeElement.scrollTop = 0;
  }
  onSubmit() {
    const controls = this.Form.controls;
    const values = this.Form.value;

    // Проверяем форму на валидность */
    if (this.Form.invalid) {
      // Если форма не валидна, помечаем все контролы как touched **/
      Object.keys(controls).forEach((controlName) => controls[controlName].markAsTouched());

      this.scrollToTop();
      this.notifierWrapService.notify('error', 'Укажите название беседы');
      return;
    }
    this.Service.chatNew(values.title, Object.keys(this.usersSelect)).subscribe(
      (result: any) => {
        result.service_type = this.Service.type;
        this.allService.arChat.push(result);
        this.allService.arChat = this.appService.chatSort(this.allService.arChat);
        this.openChat(result.id);
        this.notifierWrapService.notify('info', 'Беседа создана');
        this.cd.detectChanges();
      },
      (error) => {
        this.cd.detectChanges();
        this.interfaceService.errorHandling(error);
      }
    );
  }
  openChat(id) {
    this.appService.openChat(id, this.Service.type);
    // this.router.navigate([`/${this.Service.type}/chat/${id}`]);
    this.onClose.emit(true);
  }
  onClosed(dismissedAlert: any): void {
    this.alerts = this.alerts.filter((alert) => alert !== dismissedAlert);
  }

  clearUsersSelect() {
    this.usersSelect = [];
    this.cd.detectChanges();
  }

  showError() {
    if (this.usersSelectCount === 0) {
      this.notifierWrapService.notify('error', 'Отметьте участников');
    }
  }
}
